import React from 'react';
import CSSModules from 'react-css-modules';
import Cookies from 'universal-cookie';

import NavHead from '../NavHead';
import LayoutContainer from '../EditorPanel/ManageSections/LayoutContainer';
import CookieWarning from '../CookieWarning';
import styles from './styles.module.css';

const cookies = new Cookies();

class TabletView extends React.Component {

  constructor(props) {

    super(props);

    cookies.get('cookiesAccepted');

    this.state = {
      matches: null,
      isScrolling: false,
    };

    this.sentinel = React.createRef();

    this.updateMatches = this.updateMatches.bind(this);
    this.documentReady = this.documentReady.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

  }

  componentDidMount() {

    if (typeof window !== 'undefined') {

      const fonts = new Set();

      Object.keys(this.props.pageContext.themeData.typography).forEach(key => {

        const font = this.props.pageContext.themeData.typography[key];
        fonts.add(key === 'logo' ? font.name : `${font.name}:${font.weight}`);

      });

      if (fonts.size > 0) {

        // eslint-disable-next-line global-require
        const WebFont = require('webfontloader');

        WebFont.load({
          google: {
            families: Array.from(fonts),
          },
        });

      }

    }

    const breakpoint = '769px';
    this.mediaQueryList = window.matchMedia(`(min-width: ${breakpoint})`);
    this.mediaQueryList.addListener(this.updateMatches);

    this.setState({
      matches: window.matchMedia(`(min-width: ${breakpoint})`).matches,
    });

    if (this.props.pageContext.navigation.data[0].fixed_top) {

      const elem = this.sentinel.current;
      if (elem) {

        const observer = new IntersectionObserver(this.handleScroll);
        observer.observe(elem);

      }

    }

    this.scrollTo();

  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState.isScrolling === this.state.isScrolling) this.scrollTo();

  }

  componentWillUnmount() {

    if (this.mediaQueryList) {

      this.mediaQueryList.removeListener(this.updateMatches);

    }

  }

  scrollTo() {

    if (
      window
      && (
        (
          window.history
          && window.history.state
          && window.history.state.scrollToSection
        )
        || (window.location && window.location.hash)
      )
    ) {

      window.requestAnimationFrame(() => {

        if (document && document.readyState === 'complete') {

          const hash = window.history && window.history.state
            && window.history.state.scrollToSection
            ? `#${window.history.state.scrollToSection}` : window.location.hash;
          const ele = document.getElementById(hash);

          if (ele) {

            setTimeout(() => {

              const eleTop = ele.getBoundingClientRect().top;
              const scrollOffset = window.pageYOffset || document.documentElement.scrollTop;
              const offset = 12;
              const target = eleTop + scrollOffset + offset;

              window.scrollTo({
                top: target,
                behavior: 'smooth',
              });

            }, 90);

          }

        } else {

          setTimeout(() => {

            this.scrollTo();

          }, 200);

        }

      });

    }

  }

  handleScroll(entries) {

    if (this.props.pageContext.navigation.data[0].fixed_top) {

      this.setState({
        isScrolling: !entries[entries.length - 1].isIntersecting,
      });

    }

  }

  updateMatches() {

    this.setState({
      matches: this.mediaQueryList.matches,
    });

  }

  documentReady(callbackFunction) {

    if (typeof document !== 'undefined') {

      if (document.readyState !== 'loading') {

        callbackFunction();

      } else {

        document.addEventListener('DOMContentLoaded', callbackFunction);

      }

    }

  }

  render() {

    let ready = false;
    if (typeof document !== 'undefined') {

      this.documentReady(() => {

        ready = true;

      });

    }

    const render = [];
    let overlay;

    this.props.pageContext.page.sections.forEach((section, index) => {

      if (section.type === 'NAVIGATION') {

        ({ overlay } = section.data[0]);

      } else {

        render.push(<LayoutContainer
          pageContext={this.props.pageContext}
          key={`Layout_${this.props.pageContext.page.sections[index]._id}`}
          section={this.props.pageContext.page.sections[index]}
          overlay={index === 1 && overlay === true}
          matches={this.state.matches}
          isScrolling={this.state.isScrolling}
        />);

      }

    });

    return (
      <div className={styles.renderWrapper}>
        <div className={styles.renderContainer}>
          <div id="modal-root" />
          <div ref={this.sentinel} />
            <div id="tablet-container" className={styles.tabletContainer}>
              <NavHead isScrolling={this.state.isScrolling} pageContext={this.props.pageContext} />
              { render }
            </div>
            {
              (
                this.props.pageContext.cookie
                && this.props.pageContext.cookie.active === true
                && cookies
                && cookies.cookies
                && cookies.cookies.cookiesAccepted === undefined
                && ready === true
              )
              && (
                <CookieWarning
                  colors={this.props.pageContext.themeData.colors}
                  cookie={this.props.pageContext.cookie}
                />
              )
            }
        </div>
      </div>
    );

  }

}

export default CSSModules(TabletView, styles, { allowMultiple: true });
